import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContainerComponent } from './core/components/container/container.component';
import { canActivate } from './shared/guards/auth.guard';
import { roleGuard } from './shared/guards/role.guard';
import { Roles } from './shared/enums/roles.enum';
import { ErrorPageComponent } from './modules/nopage/components/error-page/error-page.component';
import { UnauthorizedPageComponent } from './modules/nopage/components/unauthorized-page/unauthorized-page.component';
import { ForbiddenPageComponent } from './modules/nopage/components/forbidden-page/forbidden-page.component';

const routes: Routes = [
  {
      path: '',
      component: ContainerComponent,
      canActivate: [canActivate],
      children: [
        {
          path: '',
          loadChildren: () =>
            import('./../app/modules/home/home.module').then((m) => m.HomeModule),
        },
        {
          path: 'vehicles',
          canActivate: [roleGuard],
          data: {
            roles: [Roles.SuperAdmin, Roles.CountryAdmin, Roles.User, Roles.VendorAdmin, Roles.NLBUser, Roles.NLBLGSales]
          },
          loadChildren: () =>
            import('./../app/modules/vehicles/vehicles.module').then(
              (m) => m.VehiclesModule,
          )
        },
        {
          path: 'offers',
          canActivate: [roleGuard],
          data: {
            roles: [Roles.SuperAdmin, Roles.CountryAdmin, Roles.User, Roles.VendorAdmin, Roles.NLBUser, Roles.NLBLGSales]
          },
          loadChildren: () =>
            import('./../app/modules/offers/offers.module').then((m) => m.OffersModule),
        },
        {
          path: 'admin',
          canActivate: [roleGuard],
          data: {
            roles: [Roles.SuperAdmin, Roles.CountryAdmin, Roles.NLBLGSales]
          },
          loadChildren: () =>
            import('./../app/modules/admin/admin.module').then((m) => m.AdminModule),
        }
      ]
    },
    {
      path: 'login',
      loadChildren: () =>
        import('./../app/modules/login/login.module').then((m) => m.LoginModule),
    },
    {
      path: 'forbidden',
      component: ForbiddenPageComponent,
    },
    {
      path: 'unauthorized',
      component: UnauthorizedPageComponent,
    },
     {
      path: 'general-error',
      component: ErrorPageComponent,
    },
    {
      path: '**',
      component: ContainerComponent,
      loadChildren: () =>
        import('./../app/modules/nopage/nopage.module').then((m) => m.NoPageModule),
    }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
